/**
 * Helpers for creating SuperAdmin Files instance
 */

import type { IBaseSuperAdmin } from "../../BaseSuperAdminFactory";
import type { File } from "le-coffre-resources/dist/SuperAdmin";
import type { QueryPayload } from "../../../../types";
import type { IGetFilesparams, IPutFilesParams, IPostFilesParams } from "../Files";
import {
	createGetMethod,
	createPostMethod,
	createGetUploadLinkMethod,
	createGetByUidMethod,
	createPutMethod,
	createDeleteMethod,
} from "./filesMethodsHelpers";

export interface FilesInstance {
	get(q: IGetFilesparams): Promise<File[]>;
	post(body: IPostFilesParams): Promise<File>;
	getUploadLink(uid: string): string;
	getByUid(uid: string, q?: QueryPayload): Promise<File>;
	put(uid: string, body: IPutFilesParams): Promise<File>;
	delete(uid: string): Promise<File>;
}

/**
 * Create Files instance with all methods
 */
export function createFilesInstance(baseSuperAdmin: IBaseSuperAdmin): FilesInstance {
	const baseUrl = baseSuperAdmin.namespaceUrl.concat("/files");

	return {
		get: createGetMethod(baseSuperAdmin, baseUrl),
		post: createPostMethod(baseSuperAdmin, baseUrl),
		getUploadLink: createGetUploadLinkMethod(baseUrl),
		getByUid: createGetByUidMethod(baseSuperAdmin, baseUrl),
		put: createPutMethod(baseSuperAdmin, baseUrl),
		delete: createDeleteMethod(baseSuperAdmin, baseUrl),
	};
}
